import React from 'react';
import { Button } from './ui/button';
import { Barcode } from '@phosphor-icons/react';
import { useBarcode } from '../contexts/BarcodeScannerContext';

const BarcodeScanButton = ({ onScan, size = 'default', className = '' }) => {
  const { openScanner } = useBarcode();

  const handleClick = () => {
    openScanner((scannedCode) => {
      if (onScan) {
        onScan(scannedCode);
      }
    });
  };

  return (
    <Button
      type="button"
      size={size}
      variant="outline"
      onClick={handleClick}
      className={`flex-shrink-0 min-w-[44px] min-h-[44px] md:min-w-0 md:min-h-0 ${className}`}
      title="Scan Barcode"
      data-testid="barcode-scan-button"
    >
      <Barcode size={20} weight="duotone" className="md:w-[18px] md:h-[18px]" />
    </Button>
  );
};

export default BarcodeScanButton;
